<template>
    <div>
        <el-breadcrumb separator=">" class="bread">
            <el-breadcrumb-item >销售交易</el-breadcrumb-item>
            <el-breadcrumb-item>交易详情</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>交易详情</span>
                <el-button style="margin-left: 80px;" @click="returnNext()">返回</el-button>
            </div>
            <div>
                <div><h4 style="font-weight: bolder">订单编号:  {{orderNo}}</h4></div>
                <div>
                    <el-table :data="tableData" border style="width: 100%">
                        <el-table-column prop="name" label="商品名称" ></el-table-column>
                        <el-table-column prop="SKU" label="SKU" ></el-table-column>
                        <el-table-column prop="price" label="单价" >
                            <template scope="scope" >
                                ￥{{scope.row.price / 100}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="wechatPrice" label=" 第三方支付金额" >
                            <template scope="scope" >
                                ￥{{scope.row.wechatPrice / 100}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="scorePrice" label="积分抵扣金额" v-if=" paymentMethod == 'score:1983'">
                            <template scope="scope" >
                                ￥{{scope.row.scorePrice / 100}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="proStatus" label="商品状态"></el-table-column>
                        <el-table-column prop="payStatus" label="支付状态"></el-table-column>
                        <el-table-column prop="refundPrice" label="可退金额">
                            <template scope="scope" >
                                ￥{{scope.row.refundPrice / 100}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="address" label="操作" v-if="paymentMethod == 'score:1983' || paymentMethod == 'unionPay' ">
                            <template scope="scope" >
                                <!--<el-button type="danger"  size="small" @click="refundPro(scope.row)">退款</el-button>-->
                                <el-button type="danger" v-if="scope.row.refundPrice > 0 && paymentMethod == 'score:1983'"  size="small" @click="refundPro(scope.row)">退款</el-button>
                                <el-button type="danger" v-if="scope.row.refundPrice == 0 "  size="small" :disabled="true">退款</el-button>
                                <el-button type="danger" v-if="scope.row.refundPrice > 0 && paymentMethod == 'unionPay'"  size="small" @click="posrefundPro(scope.row)">退款</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

        </el-card>

    </div>
</template>
<script>

    import axios from 'axios'// 引入axios
    import ElButton from "../../../../node_modules/element-ui/packages/button/src/button.vue";

    export  default{
        components: {
            ElButton
        },
        data(){
            return{
                orderNo:'',
                tableData:[],
                paymentMethod:'',
            }
        },
        created(){
            var data = this.$route.query.row
            this.orderNo = data.orderNo;
            this.paymentMethod = this.$route.query.row.paymentMethod;
            if(this.paymentMethod == 'score:1983'){
                this.getData();
            }else {
                this.getOrderInfo();
            }

        },
        methods: {
            getOrderInfo(){
                this.$http.get(this.productURL+"/vueFeign/findPayProRefund?orderNo="+this.orderNo)
                    .then(response => {
                        if (response.body.Code === '200') {
                            this.tableData = response.data.Data;
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            getData(){
                this.$http.get(this.deviceHost+"/scorePay/api/score/findOrderByFxOrderId?orderId="+this.orderNo)
                    .then(response => {
                        if (response.body.Code === '200') {
                            var that = this;
                            axios({
                                method: 'post',
                                url: this.productURL+"/vueFeign/findProductRefRecord",
                                data: response.body.Data
                            }).then(function(res) {
                                if (res.status === 200) {
                                    that.tableData = res.data.proArray;
                                }
                            });

                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            refundPro(row){
                this.$confirm('你确定要退款吗？退款是不可恢复的', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var params = {
                        orderNo:this.orderNo,
                        deviceId:row.deviceId,
                        refundAmt:row.price,
                        productId:row.productId,
                        SKU:row.SKU
                    }
                    //异步请求
                    this.$http.post(this.productURL+"/vueFeign/refundPro",params)
                        .then(response => {
                            if (response.status === 200) {
                                if(response.body.Code=='200'){
                                    this.getData();
                                    this.$message({ showClose: true, message: "申请退款成功",  type: 'success' });
                                }else{
                                    this.$message({ showClose: true, message: "申请退款失败",  type: 'error' });
                                }
                            }
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        })
                })
            },
            posrefundPro(row){
                this.$confirm('你确定要退款吗？退款是不可恢复的', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var params = {
                        orderNo:this.orderNo,
                        tenantId:this.getcookie('storeId'),
                        refundAmt:row.price,
                        SKU:row.SKU
                    }
                    //异步请求
                    this.$http.post(this.productURL+"/vueFeign/posRefundPro",params)
                        .then(response => {
                            if (response.status === 200) {
                                if(response.body.Code=='200'){
                                    this.getOrderInfo();
                                    this.$message({ showClose: true, message: "申请退款成功",  type: 'success' });
                                }else{
                                    this.$message({ showClose: true, message: "申请退款失败",  type: 'error' });
                                }
                            }
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        })
                })
            },
            returnNext(){
                this.$router.push( {path:"trade",query:{branchNo:this.$route.query.branchNo,kioskNo:this.$route.query.kioskNo,
                    orderStatus:this.$route.query.orderStatus,orderType:this.$route.query.orderType,orderId:this.$route.query.orderId,
                    startTime:this.$route.query.startTime,endTime:this.$route.query.endTime}});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// orderInfo.vue?2c1af260